import { ReportingShellControllerBaseConfig } from '../../../base';
import { ChatOverlayController } from './chatOverlayInterface';
import { ChatOverlayViewProps } from './chatOverlayProps';
import { ChatOverlayAggregate } from './chatOverlayModel';

export function createChatOverlayController(
    config: ReportingShellControllerBaseConfig
): ChatOverlayController {
    return {
        useProps(context, item, props): ChatOverlayViewProps {
            return {
                width: props.width,
                minWidth: props.minWidth,
                maxWidth: props.maxWidth,
                initialWidth: props.initialWidth,
                overlay: {
                    isOpen: props.overlay.disclosure.isOpen,
                    close: {
                        button: {
                            onClick: props.overlay.disclosure.onClose,
                        },
                    },
                },
                layout: {
                    thread: props.thread?.id ?? null,
                },
                page: props.thread
                    ? {
                          id: 'detail',
                          props: {
                              content: props.content?.id ?? null,
                              thread: props.thread.id,
                          },
                      }
                    : {
                          id: 'create',
                          props: {},
                      },
            };
        },
    };
}
